export enum DepartmentEnum {
    SALES = "Sales",
    FINANCE = "Finance",
    SERVICE = "Service",
    BODY_SHOP = "Body Shop",
    PARTS = "Parts",
}